import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { ExpenseService } from '../../../service/expense/expense.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { SalesGroupOwnerService } from '../../../service/sales-group-owner/sales-group-owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'app-root',
  templateUrl: 'wa8011.component.html',
  styleUrls: ['wa8011.component.css']
})
export class Wa8011Component implements AfterViewInit {
  public componentTitle = 'WA8011:諸掛登録';

  public owners: any;
  public salesgroups: any;
  public salesgroupowners: any;
  public allsalesgroupowners: any;

  public ownerId: FormControl;
  public bookDt: FormControl;
  public salesgroupId: number;
  public salesgroupTx: string;
  public pcsNr: FormControl;
  public salesgroupunitTx: string;
  public unitpricedispNr: number;
  public typetaxCd: string;
  public typetaxTx: string;
  public pricedispNr: number;
  public expensememoTx: FormControl;
  public expensetaxNr: number;

  public show = false;

  public validation = validation;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  constructor(
    private router: Router,
    private expenseService: ExpenseService,
    private ownerService: OwnerService,
    private salesGroupOwnerService: SalesGroupOwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    (this.ownerId = new FormControl('', [Validators.required])),
      (this.bookDt = new FormControl(new Date().toJSON().slice(0, 10), [Validators.required])),
      (this.pcsNr = new FormControl('', [
        Validators.pattern(validation.decimal_3),
        Validators.pattern(validation.exclude0),
        Validators.max(validation.pcsNr.maxNr),
        Validators.min(validation.pcsNr.minNr)
      ]));
    this.expensememoTx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.expensememoTx.maxLength)
    ]);
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  getSalesgrouowners(): any[] {

    let tmpsalesgroupowners;

    if (this.ownerId.value !== undefined && this.allsalesgroupowners !== undefined) {
      tmpsalesgroupowners = this.allsalesgroupowners.filter((item, index) => {
        if (item.ownerId === this.ownerId.value) {
          return true;
        }
      });
    }

    return tmpsalesgroupowners;
  }

  changeOwner(event) {
    this.salesgroups = this.getSalesgrouowners();
    this.salesgroupowners = this.getSalesgrouowners();

    if (this.salesgroups.length === 0) {
      this.show = false;
      this.salesgroupId = -1;
    } else {
      this.show = true;
      this.salesgroupId = this.salesgroupowners[0]['salesgroupId'];
    }
  }

  getSalesgroupunitTx(): string {
    if (this.salesgroupId === -1) {
      return;
    }

    if (this.salesgroups !== undefined && this.salesgroupId !== undefined) {
      var salesgroup = this.salesgroups.filter((item, index) => {
        if (item.salesgroupId == this.salesgroupId) return true;
      });
      this.salesgroupunitTx = salesgroup[0].salesgroupunitTx;
    }
    return this.salesgroupunitTx;
  }

  getUnitpricedispNr(): number {
    if (this.salesgroupId === -1) {
      return;
    }

    if (this.salesgroupowners !== undefined && this.salesgroupId !== undefined) {
      var salesgroupowner = this.salesgroupowners.filter((item, index) => {
        if (item.salesgroupId == this.salesgroupId) return true;
      });
      this.unitpricedispNr = salesgroupowner[0].unitpricedispNr;
    }
    return this.unitpricedispNr;
  }

  getTypetaxTx(): string {
    if (this.salesgroupId === -1) {
      return;
    }

    if (this.salesgroupowners !== undefined && this.salesgroupId !== undefined) {
      var salesgroupowner = this.salesgroupowners.filter((item, index) => {
        if (item.salesgroupId == this.salesgroupId) return true;
      });
      this.typetaxTx = salesgroupowner[0].typetaxTx;
    }
    return this.typetaxTx;
  }

  getPricedispNr() {
    if (this.salesgroupId === -1) {
      return;
    }

    if (this.salesgroupowners !== undefined && this.salesgroupId !== undefined) {
      var salesgroupowner = this.salesgroupowners.filter((item, index) => {
        if (item.salesgroupId == this.salesgroupId) return true;
      });
      var tmpPricedispNr = salesgroupowner[0].unitpricedispNr * this.pcsNr.value;
      this.pricedispNr = Math.round(Math.abs(tmpPricedispNr)) * ((tmpPricedispNr < 0) ? -1 : 1 );
    }
    return this.pricedispNr;
  }

  getExpensetaxNr() {
    if (this.salesgroupId === -1) {
      return;
    }

    if (this.salesgroupowners !== undefined && this.salesgroupId !== undefined) {
      var salesgroupowner = this.salesgroupowners.filter((item, index) => {
        if (item.salesgroupId == this.salesgroupId) return true;
      });
      this.expensetaxNr = this.pricedispNr * 0.08;
    }
    return this.expensetaxNr;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
    // setTimeout(() => {
    //   this.onView();
    // }, 500);
  }

  onView() {
    this.working = true;
    this.ownerService
      .get()
      .then(outputJson => {
        this.working = false;
        // console.log(JSON.stringify(outputJson));
        // console.log(outputJson);
        this.owners = outputJson.owners;
        this.ownerId.setValue(this.owners[0]['ownerId']);
        // 絞込みにownerIdが必要なので、あえて直列に実行
        this.salesGroupOwnerService
          .get()
          .then(outputJson2 => {
            this.working = false;
            // console.log(JSON.stringify(outputJson));
            console.log(outputJson2);
            // 単価が定義された売上分類のみ取得するため、売上分類ではなく、荷主別売上分類を利用する
            this.allsalesgroupowners = outputJson2.salesgroupowners;
            this.salesgroups = this.getSalesgrouowners();
            this.salesgroupowners = this.getSalesgrouowners();

            if (this.salesgroups.length === 0) {
              this.salesgroupId = -1;
              this.show = false;
            } else if (this.salesgroupowners !== undefined) {
              this.salesgroupId = this.salesgroupowners[0]['salesgroupId'];
              this.show = true;
            } else {
              this.show = true;
            }

          })
          .catch(error => {
            this.working = false;
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {

    var expensememoTx = this.expensememoTx.value.trim();
    let errors = false;
    if (this.pricedispNr > validation.pricedispNr.maxNr) {
      this.errorInfo = validation.message.priceOver + validation.pricedispNr.maxNr.toString();
      return;
    }
    if (this.ownerId.errors !== null) {
      this.ownerId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.bookDt.errors !== null) {
      this.bookDt.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.pcsNr.errors !== null) {
      this.pcsNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.expensememoTx.errors !== null) {
      this.expensememoTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }

    const salesgroup = this.salesgroups.filter((item, index) => {
      if (item.salesgroupId === this.salesgroupId) {
        return true;
      }
    });

    if (salesgroup.length === 0) {
      return;
    }

    this.salesgroupTx = salesgroup[0].salesgroupTx;

    const salesgroupowner = this.salesgroupowners.filter((item, index) => {
      if (item.salesgroupId === this.salesgroupId) {
        return true;
      }
    });

    this.typetaxCd = salesgroupowner[0].typetaxCd;
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.expenseService
      .post(
        this.ownerId.value,
        new Date(this.bookDt.value),
        +this.salesgroupId,
        this.unitpricedispNr,
        this.pcsNr.value,
        this.pricedispNr,
        this.typetaxCd,
        0,
        expensememoTx,
        'wa8011'
      )
      .then(outputJson => {
        this.working = false;
        this.router.navigate(['wa8010']);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa8Billing/wa8011/wa8011.component.ts